<form [formGroup]="address">
  <!--Calle, avenida, etc-->
  <label class="col-form-label col-form-label-sm">Dirección</label>
  <div class="row">
    <ng-container *ngIf="!oneField; else inline">
      <div class="col-sm-12 col-md-6 col-lg-6" [ngClass]="{ 'col-md-12': size, 'col-lg-12': size }">
        <div class="form-group" [ngClass]="{
            'text-danger': address.controls.street?.invalid && address.controls.street.touched
            || address.controls.streetNumber?.invalid && address.controls.streetNumber.touched
            || address.controls.houseNumber?.invalid && address.controls.houseNumber.touched
            || address.controls.oficeNumber?.invalid && address.controls.oficeNumber.touched }">
          <div class="input-group">
            <div class="input-group-prepend">
              <ng-select
                class="custom" 
                [items]="streetList" 
                bindLabel="valueId" 
                bindValue="valueId"
                loadingText="Cargando por favor espere..."
                placeholder="Selecciona"
                [clearable]="false"
                [searchable]="false"
                formControlName="street"
                [readonly]="editable == false"
                (focusout)="addressConstruction()">
                <ng-template ng-option-tmp let-item="item">
                  <div>{{item.name}}</div>
                </ng-template>
              </ng-select>
            </div>
            <input  type="text"  class="form-control form-control-sm mr-2"
                    formControlName="streetNumber"
                    [readonly]="editable == false"
                    [imask]="wordMask"
                    (focusout)="addressConstruction()">
            <label class="col-form-label col-form-label-sm"> # </label>
            <input  type="text" [imask]="wordMask" class="form-control form-control-sm ml-2 mr-2"
                    formControlName="houseNumber"
                    [readonly]="editable == false"
                    (focusout)="addressConstruction()">
            <label class="col-form-label col-form-label-sm"> - </label>
            <input  type="number" class="form-control form-control-sm ml-2"
                    formControlName="oficeNumber"
                    [readonly]="editable == false"
                    (focusout)="addressConstruction()"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    min="0">
          </div>
          <div *ngIf="address.controls.street?.errors
                      && (address.controls.street.dirty || address.controls.street.touched)
                      || address.controls.streetNumber?.errors
                      && (address.controls.streetNumber.dirty || address.controls.streetNumber.touched)
                      || address.controls.houseNumber?.errors
                      && (address.controls.houseNumber.dirty || address.controls.houseNumber.touched)
                      || address.controls.oficeNumber?.errors
                      && (address.controls.oficeNumber.dirty || address.controls.oficeNumber.touched)
                      ">
            <span *ngIf="address.controls.street.errors?.required
                         || address.controls.streetNumber.errors?.required
                         || address.controls.houseNumber.errors?.required
                         || address.controls.oficeNumber.errors?.required">Requerido</span>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-3" [ngClass]="{ 'col-md-12': size, 'col-lg-12': size }">
        <!--Numero de carrera-->
        <div class="form-group" [ngClass]="{
            'text-danger': address.controls.apartment?.invalid && address.controls.apartment.touched
            || address.controls.apartmentNumber?.invalid && address.controls.apartmentNumber.touched}">
          <div class="input-group">
            <div class="input-group-prepend">
              <ng-select
                class="custom" 
                [items]="apartmentList" 
                bindLabel="valueId" 
                bindValue="valueId"
                loadingText="Cargando por favor espere..."
                placeholder="Selecciona"
                [clearable]="false"
                [searchable]="false"
                formControlName="apartment"
                [readonly]="editable == false"
                (focusout)="addressConstruction()">
                <ng-template ng-option-tmp let-item="item">
                  <div>{{item.name}}</div>
                </ng-template>
              </ng-select>
            </div>
            <input  type="text" [imask]="wordMask" class="form-control form-control-sm"
                    formControlName="apartmentNumber"
                    [readonly]="editable == false"
                    (focusout)="addressConstruction()">
          </div>
          <div *ngIf="address.controls.apartment?.errors
                      && (address.controls.apartment.dirty || address.controls.apartment.touched)
                      || address.controls.apartmentNumber?.errors
                      && (address.controls.apartmentNumber.dirty || address.controls.apartmentNumber.touched)">
            <span *ngIf="address.controls.apartment.errors?.required
                        || address.controls.apartmentNumber.errors?.required">Requerido</span>
          </div>
        </div>
      </div>
        <!--Numero de casa u oficina-->
      <div class="col-sm-12 col-md-6 col-lg-3" [ngClass]="{ 'col-md-12': size, 'col-lg-12': size }">
        <div class="form-group" [ngClass]="{
          'text-danger': address.controls.neighborhood?.invalid && address.controls.neighborhood.touched
          || address.controls.neighborhoodField?.invalid && address.controls.neighborhoodField.touched}">
          <div class="input-group">
            <div class="input-group-prepend">
              <ng-select
                class="custom"
                [items]="neighborhoodList" 
                bindLabel="valueId" 
                bindValue="valueId"
                loadingText="Cargando por favor espere..."
                placeholder="Selecciona"
                [clearable]="false"
                [searchable]="false"
                formControlName="neighborhood"
                [readonly]="editable == false"
                (focusout)="addressConstruction()">
                <ng-template ng-option-tmp let-item="item">
                  <div>{{item.name}}</div>
                </ng-template>
              </ng-select>
            </div>
            <input  type="text" [imask]="wordMask" class="form-control form-control-sm"
                      formControlName="neighborhoodField"
                      [readonly]="editable == false"
                      (focusout)="addressConstruction()">
            </div>
            <div *ngIf="address.controls.neighborhood?.errors
                        && (address.controls.neighborhood.dirty || address.controls.neighborhood.touched)
                        || address.controls.neighborhoodField?.errors
                        && (address.controls.neighborhoodField.dirty || address.controls.neighborhoodField.touched) ">
              <span *ngIf="address.controls.neighborhood.errors?.required
                          || address.controls.neighborhoodField.errors?.required">Requerido</span>
            </div>
        </div>
      </div>
    </ng-container>
    <ng-template #inline>
      <div class="col-sm-12 col-md-6 col-lg-6" [ngClass]="{ 'col-md-12': size, 'col-lg-12': size }">
        <input type="text" class="form-control form-control-sm" [readonly]="editable == false" formControlName="inlineAddress" (focusout)="setInlineAddress()">
      </div>
    </ng-template>
  </div>
</form>
